/**
 * mm-variant-gallery.js
 * - Thumbnail navigation + click-to-zoom lightbox for the MM variant gallery.
 * - Swaps the gallery when the selected variant changes (Horizon fires
 *   `shopify:product:select`; the re-rendered section HTML is delivered via
 *   event.promise -> detail.html).
 * No dependencies, no bundler required.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-mm-variant-gallery]';

  var lightbox = null;

  function openLightbox(src, alt) {
    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'mm-vg-lightbox';
      lightbox.setAttribute('role', 'dialog');
      lightbox.setAttribute('aria-modal', 'true');
      lightbox.innerHTML =
        '<button class="mm-vg-lightbox__close" type="button" aria-label="Close">&times;</button>' +
        '<img class="mm-vg-lightbox__img" alt="">';
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target.classList.contains('mm-vg-lightbox__close')) {
          closeLightbox();
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeLightbox();
      });
      document.body.appendChild(lightbox);
    }
    lightbox.querySelector('.mm-vg-lightbox__img').src = src;
    lightbox.querySelector('.mm-vg-lightbox__img').alt = alt || '';
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (lightbox) lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function init(el) {
    if (!el || el.dataset.mmInit === '1') return;
    el.dataset.mmInit = '1';

    var mainImg = el.querySelector('.mm-vg-main-img');
    var thumbs = el.querySelectorAll('.mm-vg-thumb');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.src;
        if (mainImg && src) {
          mainImg.src = src;
          mainImg.dataset.zoomSrc = thumb.dataset.zoomSrc || '';
        }
        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-selected', 'true');
      });
    });

    if (el.dataset.zoom === 'true' && mainImg) {
      var zoomHandler = function () {
        var zoomSrc = mainImg.dataset.zoomSrc || mainImg.src;
        openLightbox(zoomSrc, mainImg.alt);
      };
      mainImg.addEventListener('click', zoomHandler);
      mainImg.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          zoomHandler();
        }
      });
    }
  }

  function initAll() {
    var els = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  function swapOnVariantChange(e) {
    if (!e.promise || typeof e.promise.then !== 'function') return;
    e.promise
      .then(function (data) {
        var html = data && data.detail && data.detail.html;
        if (!html || typeof html.querySelector !== 'function') return;
        var incoming = html.querySelector(SELECTOR);
        if (!incoming) return;
        var current = document.querySelector(SELECTOR);
        if (current && current.parentNode) {
          current.replaceWith(incoming);
          init(incoming);
        }
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:product:select', swapOnVariantChange);
})();
